define([
	"dojo/_base/declare",
	"dojo/when",
	"csi/html",
	"csi/locale",
	"csi/state/rootStore",
	"csi/store/UserNames",
	"csi/types",
	"csi/view/ToolbarDropDown",
	"csi/xml"
], function(declare, when, html, locale, {sessionStore}, UserNames, types, ToolbarDropDown, xml) {

	return declare(ToolbarDropDown, {
		/**
		 * @override
		 * Render delegated user status flag and title if necessary
		 */
		buildRendering: function() {
			this.inherited(arguments);

			const {user} = sessionStore;
			const now = types.getDateTime();
			const start = user.DelegationStartTime;
			const end = user.DelegationEndTime;
			const userUrl = user.DelegationUser;

			if (xml.isValidURL(userUrl) && (now >= start) && (now < (end + 86400))) {
				when(UserNames.load(), () => {
					html.create("span", {
						className: "csi-user-delegation",
						innerText: "!",
						title: locale.resource("DelegateTo", [
							UserNames.get(userUrl),
							types.formatTime(start),
							types.formatTime(end)
						])
					}, this.domNode);
				});
			}
		},

		/**
		 * @override
		 * Set custom tooltip for icon
		 */
		postMixInProperties: function() {
			this.title = locale.resource("UserProfileMenu", [sessionStore.userName]);
			this.inherited(arguments);
		}
	});
});